import { Command } from '@/app/common/base/command'

export class DownloadInvoiceCommand extends Command {
    public async run(id: string) {
        const response = await this.client.download(
            `/api/invoices/download/${id}`, {
                responseType: 'blob',
                timeout: 30000
            },
            true
        )

        let filename = ''
        const disposition: any = response.headers['content-disposition']

        if (disposition && disposition.indexOf('attachment') !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            const matches = filenameRegex.exec(disposition)

            if (matches?.[1]) {
                filename = matches[1].replace(/['"]/g, '')
            }
        }

        const fileURL = window.URL.createObjectURL(response.data)
        const fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute('download', decodeURI(filename))
        document.body.appendChild(fileLink)
        fileLink.click()
    }
}
